export class EmailProperties {

    public EmailValue: string;
    public EmailPlaceholder: string;
    public EmailLabelText: string;
    public ErrorMessage: string;
    public TabIndex: string;
    public Message: string;
}
